"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.success.completed': '入职成功完成！您的AI助手已准备就绪。',
    'onboarding.success.progress_saved': '进度保存成功',
};
